import { STORAGE_POPUP_NOTIFICATION_SEEN } from './constants';

/**
 * Short, stable fingerprint of the auth token, used as an id for the login session.
 *
 * The backend hands out a new token on every login and expires the old one at the
 * end of the week, so the token doubles as an id for the current login session -
 * which is exactly how long the popup notification has to stay dismissed.
 * We store the fingerprint instead of the token itself to keep the raw credential
 * in a single place in the storage.
 */
export const getLoginSessionId = (token: string): string => {
  let hash = 0;
  for (let i = 0; i < token.length; i++) {
    hash = (hash << 5) - hash + token.charCodeAt(i);
    hash |= 0; // keep the result a 32 bit integer
  }
  return hash.toString(36);
};

export const isPopupNotificationSeen = (token: string): boolean =>
  localStorage.getItem(STORAGE_POPUP_NOTIFICATION_SEEN) === getLoginSessionId(token);

export const markPopupNotificationSeen = (token: string): void => {
  localStorage.setItem(STORAGE_POPUP_NOTIFICATION_SEEN, getLoginSessionId(token));
};

export const clearPopupNotificationSeen = (): void => {
  localStorage.removeItem(STORAGE_POPUP_NOTIFICATION_SEEN);
};
